<template lang="html">
  <div class="tab" v-show="isActive">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Tab',
  inject: ['addTab'],
  props: {
    title: {
      type: String,
      default: 'Tab',
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
  mounted() {
    this.addTab(this)
  },
}
</script>

<style lang="css" scoped>
.tab {
  margin-top: 10px;
  padding: 15px 10px;
  background-color: #eee;
}
</style>
